module.exports = function getResource(label, vars = []) {
    let resources = {
        new: 'NEW'
    };

    return resources[label];
};
